import { SparklesIcon } from "@heroicons/react/16/solid";
import { useStore } from "@nanostores/react";
import clsx from "clsx";
import { ReactElement } from "react";

import {
  $isCopilotOpen,
  closeCopilot,
  toggleCopilot,
} from "../stores/copilot.ts";
import { Button } from "./catalyst/Button.tsx";
import { AIAssistantSidebar } from "./copilot/AIAssistantSidebar.tsx";
import GraphAssistantInstructions from "./copilot/GraphAssistantInstructions.tsx";

export const GlobalCopilot = (): ReactElement => {
  const isCopilotOpen = useStore($isCopilotOpen);

  return (
    <>
      {/* Fixed Copilot Button - always visible */}
      <div
        className={clsx(
          "fixed bottom-4 right-4 z-50 transition-all duration-300 ease-in-out",
          !isCopilotOpen ? "opacity-100" : "pointer-events-none opacity-0",
        )}
      >
        <Button color="emerald" onClick={toggleCopilot} size="xs">
          <SparklesIcon className="h-4 w-4" />
        </Button>
      </div>

      {/* Copilot Sidebar */}
      <AIAssistantSidebar
        initialMessage={<GraphAssistantInstructions />}
        isOpen={isCopilotOpen}
        onClose={closeCopilot}
        placeholder="Ask Miru Copilot"
      />
    </>
  );
};
